exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidebar{\r\n    background-color: #004d9b;\r\n    color: white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n    height: auto;\r\n    padding-left: 10px;\r\n    padding-right: 0px;\r\n    width: 300px;\r\n    position: relative;\r\n    top: 50px;\r\n    padding-top: 30px;\r\n}\r\n\r\n.sidebar-navbar{\r\n    \r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: center;\r\n\r\n}\r\n\r\n.sidebar-navbar h3 {\r\n    font-weight: lighter;\r\n}\r\n\r\na .sidebar-item .list-group-item{\r\n    border-radius: 0px;\r\n}\r\n\r\n.divider-sidebar{\r\n    width: 99%;\r\n    background-color: white;\r\n}\r\n\r\n.sidebar a {\r\n    color: white;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/sidebar/sidebar/sidebar.style.css
// module id = 641
// module chunks = 0